import React, { useEffect } from "react";
import '../css/about.css';
import Management from "../components/Management";
import { useLocation } from 'react-router-dom';
const About = () => {
  const location = useLocation();
  // Scroll to the section if specified in the URL state
  useEffect(() => {
    if (location.state?.scrollTo) {
      const element = document.getElementById(location.state.scrollTo);
      if (element) {
        // Use smooth scrolling to the section
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [location]);
  return (
   <div  className="">
<div className="inspiration-sec">
<div id="SchoolDirector" className="page-heading">
    <h1>Our Inspiration</h1>
    </div>
<div class="inspriation-box">
        <div class="inpiration-left-side-box">
          <div class="inspiration-content">
{/* 
                <h2 data-aos="fade-left" data-aos-duration="1000" class="aos-init aos-animate">Our Inspiration</h2> */}
                <p data-aos="fade-left" data-aos-duration="1000" class="aos-init aos-animate">“We proudly honor the visionaries who dedicated their efforts to bringing an international standard of
education to the Pink City, Jaipur.
The driving force behind Sanskar School is the dream, initiative, and unwavering commitment of Mr.
Lachman A. Bhatia and Mr. Kanni Thahryamal, who envisioned a learning environment that seamlessly
blends modern education with rich Indian culture.”</p>
          </div>
        </div>
        <div class="inpiration-right-side-box">
                <div class="left-side-inner-img ">
                    <div class="inspiration-img">
                        <img src="../newimg/Lachman A. Bhatia.webp" alt=""/>
                    </div>
                    <div class="inspiration-text">
                        <h3 data-aos="fade-left" data-aos-duration="1000" class="aos-init aos-animate">Lachman A. Bhatia</h3>
                        <p data-aos="fade-left" data-aos-duration="1000" class="aos-init aos-animate">April 1, 1938 - July 27, 2019</p>
                    </div>
                </div>
                <div class="right-side-inner-img">
                    <div class="inspiration-img">
                        <img src="../newimg/Kanhiya Thahryamal.webp" alt=""/>
                    </div>
                    <div class="inspiration-text">
                        <h3 data-aos="fade-left" data-aos-duration="1000" class="aos-init aos-animate">Kanhiya Thahryamal</h3>
                        <p data-aos="fade-left" data-aos-duration="1000" class="aos-init aos-animate">December 20,1964 - July 1, 2006</p>
                    </div>
                </div>
        </div>
</div>

</div>

    <div id="SchoolDirector" className="page-heading">
    <h1>Board of Governors </h1>
    </div>
 

<Management/>


<div className="page-heading">
    <h1>Head of School</h1>
    </div>

<div className='principal-desk-sec school-head'>
      <div className='left-side'>
      <div className='img-box'>
      <img src="../newimg/Girdhar-Kumari.webp"/>
      </div>
      </div>
      <div className='right-side'>
      <div className='content-box'>
      <h3>Ms. Girdhar Kumari</h3>
        <h2>Principal (International Curriculum)</h2>
        <p>“The beautiful thing about learning is that no one can take it away from you.” -B.B.King</p>
        <p>Our primary focus at Sanskar is to impart a child-centered, constructive approach to learning that supports creative and intellectual growth in children. We value each child's abilites and thereby emphasize and encourage the processes that lead to self-discovery and self-expression. For us each child is a success story waiting to be written and become a bestseller.</p>
      <p></p>
        </div>
      </div>
     </div>


   <div id="MissionVision" className="mission-vision-sec">
    <div className="mission-vision-main-box">
       <div className="vision-box">
        <h1>Vision</h1>
        <div className="vission-content">
         <p>The motto of Sanskar School being ‘Revival of tradition’, we aim to prepare distinguished
         individuals with feelings, sensibilities, responsibility and compassion to live in today’s world.</p>
        </div>

      </div>
      <div className="mission-box">
      <h1>Mission</h1>
      <div className="mission-content">
          <h4> Sanskar School aims to:</h4>
          <h4> संस्कार स्कूल के लक्ष्य :</h4>
          <h4> L’école Sanskar vise à :</h4>
          <br/>
          <div className="school-mission-content">
          <ul>
            <li> <p>equip its pupils with a critical and global outlook which will make them committed citizens of the world.</p>
                  <p>अपने विद्यार्थियों को समालोचनात्मक और वैश्विक दृष्टिकोण द्वारा इस प्रकार समर्थ बनाना कि वे इस संसार के विकास हेतु प्रतिबद्ध नागरिक बन सकें |</p>
                  <p>Doter ses élèves d’une vision critique et globale qui fera d’eux des citoyens du monde engages..</p>
              </li>

            
            <br/>
         
           

            <li>
              <p>recognize and channelize the potential of the pupil and develop thinking, communication, social, scientific and interpersonal skills.</p>
              <p>विद्यार्थियों की क्षमता को पहचानना व उनका सदुपयोग सिखाना | उनकी संचार, सामाजिक, वैज्ञानिक, अंतर्वैयक्तिक क्षमता तथा विचार शक्ति का विकास करना |</p>
              <p>Reconnaitre et canaliser le potentiel de l’élève et développer la communication de la pensée, les compétences en sciences sociales et interpersonnelles.</p>
              </li>
        
         
            <br/>
            <li>
              <p>foster cognitive, affective and psychomotor development and enable the pupil to make connections with the acquired knowledge in his/her everyday life</p>
              <p> संज्ञानात्मक बोध करवाना तथा भावनात्मक व मनोप्रेरणात्मक विकास करना | विद्यार्थियों को समर्थ बनाना ताकि वे प्राप्त ज्ञान का दैनिक जीवन से सम्बन्ध स्थापित कर उसका उपयोग कर सकें |</p>
              <p> Favoriser le développement cognitif, affectif et psychomoteur et permettre à l’élève d’établir des liens avec les connaissances acquises dans sa vie quotidienne.</p>
              
              </li>
        
          </ul>

          </div>

        
      </div>
      
      </div>
     
    </div>

</div> 
   
   </div> 

   






  )
};

export default About;
